import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataService } from './data.service';

export interface SystemConfig {
    system: string;
}

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    constructor(private dataService: DataService) { }

    getSystemConfig(): Observable<SystemConfig> {
        return this.dataService.get<SystemConfig>(`api/configurations`);
    }
}
